import { useMemo } from 'react';
import { prop } from 'js/utils/ramda.util';
import { useDeviceSelector } from 'js/store/hooks';

import { TABLE_VIEW } from '../constants';

export const useActualTableView = (tableView, isForcedAccordionView) => {
    const isDesktop = useDeviceSelector(prop('isDesktop'));

    return useMemo(() => {
        if (tableView === TABLE_VIEW.AUTO && isDesktop && isForcedAccordionView) {
            return TABLE_VIEW.ACCORDION;
        }

        if (tableView === TABLE_VIEW.AUTO) {
            return isDesktop ? TABLE_VIEW.TABLE : TABLE_VIEW.ACCORDION;
        }

        return tableView;
    }, [tableView, isForcedAccordionView, isDesktop]);
};
